import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { BaseComponent } from 'src/app/moov-common/base/base.component';
import { AccountTypeEnum } from 'src/app/moov-common/services/personal-user-data/personal-user-data';

@Component({
  selector: 'app-motivation-ticket',
  templateUrl: './motivation-ticket.component.html',
  styleUrls: ['./motivation-ticket.component.scss']
})
export class MotivationTicketComponent extends BaseComponent implements OnInit {
  @Input() icon: string;
  @Input() name: string;
  @Input() trend: number;
  @Input() score: number;
  @Input() motivationColor: string;
  @Input() isTrendValueExists : boolean = false;
  @Input() isTrendValueRelevant : boolean = false;
  @Input() isUnknownScoreValue : boolean = true;
  @Input() hideTrendAndScore : boolean = true;
  @Input() presentRaiseDriver : boolean = false;
  @Input() presentEnergyLevel : boolean = true;
  @Output() moreDetails = new EventEmitter();
  @Output() raiseDriver = new EventEmitter();
  trendColor :string = '#DFE3E8';
  trendIcon : string = "question_mark";
  presentationTrend : number;


  positiveTrendIconName = "trending_up";
  negativeTrendIconName = "trending_down";
  stableTrendIconName = "trending_flat";
  noTrendDataIconName = "question_mark";
  constructor() { 
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();

    if (this.score != undefined){
      this.trendColor = this.calculateColor(this.score);
    }

    this.initData();
  }

  ngOnChanges (changes: SimpleChanges) : void {
    this.ifChanged(changes.hideTrendAndScore, ()=> {
      if (this.score != undefined){
        this.trendColor = this.calculateColor(this.score);
      }
    });
  }

  initData(): void{
    if (this.trend != undefined){
      // Change to percentage
      this.trend = this.trend*100;

      this.trendIcon = this.caclulateTrendIcon(this.trend);
      this.presentationTrend = Math.abs(this.trend);
    }
  }

  calculateColor (score: number): string{
    if (this.hideTrendAndScore){
      // score is not existent or out dated
      return 'grey';
    }
    if (score == 1 || score == 2){
      return 'red';
    }
    else if (score == 3 || score == 4){
      return 'yellow';
    }
    else {
      return 'green';
    }
  }

  caclulateTrendIcon (trendValue : number): string{
      // For now we are presenting not updated data after user's approval
      // if (this.isUnknownTrendValue){
      //   return this.noTrendDataIconName;
      // }
      if (trendValue == 0){
        return this.stableTrendIconName;
      }
      else if (trendValue > 0){
        return this.positiveTrendIconName;
      }
      else{ // trendValue < 0
        return this.negativeTrendIconName;
      }
  }

  raiseDriverClicked(): void{
    this.raiseDriver.emit();
  }

  ticketClicked(): void{
    this.moreDetails.emit();
  }

  
}
